export default "__VITE_ASSET__CfhAHzkz__"